






import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({})
export default class Tag extends Vue {
  @Prop() text!: string;
  @Prop({ default: 'green' }) colorSchema?: string;
}
